module.exports = __webpack_public_path__ + "static/img/MGVAGV.a96dfc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/MGVAGV.png
// module id = 5dRo
// module chunks = 1